// extracted by mini-css-extract-plugin
export default {"card":"card___sjGiv","popover":"popover___gjWRj"};